// extracted by mini-css-extract-plugin
export default {"cardContainer":"styles_cardContainer__K1-MB"};